import { IconX } from '@tabler/icons-react';
import SharedPrihlaskaForm from '../../../components/SharedPrihlaskaForm';

interface Person {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    address: string;
    houseNumber?: string;
    city?: string;
    psc?: string;
    rodCislo?: string;
    isBernolakova: boolean;
    schoolName?: string;
    gender?: 'MALE' | 'FEMALE';
    type: 'PARENT' | 'ADULT' | 'KID';
    schoolyearId?: string;
    schoolyear?: {
        id: string;
        name: string;
        order: number;
        type: 'PRESCHOOL' | 'PRIMARY' | 'HIGHSCHOOL' | 'UNIVERSITY';
    };
}

interface Kruzok {
    id: string;
    name: string;
    description?: string;
    price: number;
    capacity: number;
    currentRegistrations: number;
    time: string;
    surcharge: boolean;
    isStretko: boolean;
    gender: 'MALE' | 'FEMALE' | 'BOTH';
    type: 'TRIH' | 'BERN';
    requiresZapisne: boolean;
    schoolYear?: Array<{
        id: string;
        name: string;
        order: number;
        type: 'PRESCHOOL' | 'PRIMARY' | 'HIGHSCHOOL' | 'UNIVERSITY';
    }>;
}

interface Prihlaska {
    id: string;
    personId: string;
    status: 'DRAFT' | 'GENERATED' | 'ACCEPTED' | 'REJECTED' | 'CANCELLED';
    isVP: boolean;
    isCp: boolean;
    paymentOption: 'CASH' | 'EDUPAGE';
    toPay: number;
    adminSubmissionDate?: string;
    createdAt: string;
    updatedAt: string;
    person: Person;
    kruzky: Kruzok[];
}

interface AdminEditPrihlaskaModalProps {
    isOpen: boolean;
    onClose: () => void;
    prihlaska: Prihlaska;
    onSuccess: () => void;
}

const AdminEditPrihlaskaModal = ({ isOpen, onClose, prihlaska, onSuccess }: AdminEditPrihlaskaModalProps) => {
    const handleSuccess = (prihlaaskaId: string) => {
        console.log(`Prihlaska ${prihlaaskaId} successfully updated`);
        onSuccess();
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] overflow-hidden">
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <h2 className="text-xl font-semibold text-gray-900">
                        Upraviť prihlášku - {prihlaska.person.firstName} {prihlaska.person.lastName}
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <IconX className="h-6 w-6" />
                    </button>
                </div>

                <div className="overflow-y-auto max-h-[calc(90vh-120px)] p-6">
                    <SharedPrihlaskaForm
                        person={prihlaska.person}
                        existingPrihlaska={prihlaska}
                        isAdminMode={true}
                        onSuccess={handleSuccess}
                        onCancel={onClose}
                    />
                </div>
            </div>
        </div>
    );
};

export default AdminEditPrihlaskaModal;
